<template>
    <div :class="$style.right">
        <div :class="$style.right_wrapper">
            <AdContainer
                type="sidebar_fullscreen"
                :backgroundClass="$style.ad"
            />
            <AdContainer
                type="sidebar_bottom_fullscreen"
                :backgroundClass="$style.ad"
            />
        </div>
    </div>
</template>
<script lang="ts" setup>
import AdContainer from '@/components/AdContainer/AdContainer.vue'
</script>
<style module>
.right {
    width: var(--global-right-pannel-width);
    display: block;
    position: relative;
}

.ad {
    background-color: var(--experimental-purple-graphit);
    border-radius: var(--radius-12);
}

.right_wrapper {
    display: grid;
    grid-template-rows: auto minmax(0, 1fr);
    gap: 8px;
}
</style>
